import { Box } from '@factorialco/deprecated-design-system'
import { PerformanceGoalsMetricProgressFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { normalizeMetric } from 'modules/performance_goals/lib/normalizeMetric'

import { GoalProgressBar } from '../GoalProgressBar'

interface Props {
  metric: PerformanceGoalsMetricProgressFragment
}

export const MetricProgress: React.FC<Props> = ({ metric }) => {
  const normalizedMetric = normalizeMetric(metric)

  const showNeedsAttention =
    normalizedMetric.progressAssessmentStatus === 'at_risk' ||
    normalizedMetric.progressAssessmentStatus === 'highly_at_risk'

  const expectedProgressLabel =
    normalizedMetric.type === 'quantitative'
      ? i18n.t('performance_goals.metric_progress.expected_progress_quantitative', {
          progress: `${normalizedMetric.expectedProgress}%`,
        })
      : i18n.t('performance_goals.metric_progress.expected_progress_qualitative')

  return (
    <Box minWidth="s120" width="full">
      <GoalProgressBar
        progress={metric.progressPercentageValue}
        needsAttentionTooltip={
          showNeedsAttention && expectedProgressLabel ? expectedProgressLabel : undefined
        }
        needsAttention={showNeedsAttention}
      />
    </Box>
  )
}
